import _typeof from "@babel/runtime/helpers/typeof";
import { rioEvent } from './rsw';
import { captureError } from '../util/errors';
export var getRioClient = function getRioClient() {
  if (typeof window === 'undefined') return;
  if (window._rswClients && window._rswClients["default"]) return window._rswClients["default"];
  if (window.rsw9 && typeof window.rsw9.getClient === 'function') {
    return window.rsw9.getClient();
  }
  if (typeof window.getRswClient === 'function') {
    return window.getRswClient();
  }
  captureError(new Error('wtai-upload-widget: Rio SDK client not found'));
};
export var initializeWtaClient = function initializeWtaClient(options) {
  var client = getRioClient();
  if (client) {
    return client.init(options);
  }
  return client;
};
var wtaAnalytics = function wtaAnalytics() {
  return function (events) {
    var client = getRioClient();
    if (!client) {
      return;
    }
    events.forEach(function (_ref) {
      var payload = _ref.payload,
        config = _ref.config;
      if (_typeof(payload) === 'object' && config) {
        rioEvent(client, payload, config)["catch"](captureError);
      }
    });
  };
};
export default wtaAnalytics;